import { ApiCallError } from '@/lib/apiErrors';

export type PatientMutationErrorKey =
  | 'conflict'
  | 'invalid_input'
  | 'forbidden'
  | 'unauthorized'
  | 'edge_function'
  | 'unknown';

const EDGE_FUNCTION_FAILED = /failed to send a request to the edge function/i;

export function patientMutationErrorKey(err: unknown): PatientMutationErrorKey {
  if (err instanceof ApiCallError) {
    switch (err.code) {
      case 'conflict':
        return 'conflict';
      case 'invalid-input':
        return 'invalid_input';
      case 'forbidden':
        return 'forbidden';
      case 'unauthorized':
        return 'unauthorized';
      case 'not-found':
      case 'rate-limited':
      case 'method-not-allowed':
      case 'stripe-not-configured':
      case 'stripe-not-onboarded':
      case 'clinio-pay-unavailable':
      case 'clinio-forms-unavailable':
      case 'missing-clinical-reason':
      case 'internal-error':
        if (EDGE_FUNCTION_FAILED.test(err.message)) return 'edge_function';
        return 'unknown';
      default: {
        const _exhaustive: never = err.code;
        void _exhaustive;
        return 'unknown';
      }
    }
  }
  if (err instanceof Error && EDGE_FUNCTION_FAILED.test(err.message)) {
    return 'edge_function';
  }
  return 'unknown';
}

export function patientMutationErrorText(
  err: unknown,
  t: (key: string) => string,
): string {
  return t(`patients.errors.${patientMutationErrorKey(err)}`);
}
